export default "__VITE_ASSET__1a546164__"